import { ReactComponent as ModuleIcon } from "./images/moduleIcon.svg";

export const Config = {
  moduleName: "training",
  dependencies: [
    /*
      If the module relates on other module (widgets), place relation definition here.
      E.g "@news/WidgetName"
    */
  ],
  label: "Training",
  Icon: ModuleIcon,
  urls: ["/szkolenia/:id"],
  routeName: "",
  routes: {},
  options: {},
  theme: {}
};
